<template>
  <layout-no-padding>
    <transition name="fadeToggle" mode="out-in" v-if="listView">
      <v-flex>
        <v-card>
          <v-card-actions></v-card-actions>

          <v-data-table :items="dockets" :headers="headers">
            <template slot="items" slot-scope="props">
              <tr @click="openDocket(props.item)" style="cursor: pointer">
                <td class="text-xs-center">{{ props.item.id }}</td>
                <td>
                  <v-edit-dialog :return-value.sync="props.item.externalRef" lazy @cancel="cancel">
                    {{ props.item.externalRef }}
                    <v-text-field
                      slot="input"
                      v-model="props.item.externalRef"
                      label="Edit"
                      single-line
                      counter
                    ></v-text-field>
                  </v-edit-dialog>
                </td>
                <td class="text-xs-left">{{ props.item.site.name }}</td>
                <td class="text-xs-left">{{ props.item.driver.contractor.name }}</td>
                <td class="text-xs-left">{{ props.item.vehicle.name }}</td>
                <td class="text-xs-left">{{ props.item.driver.name }}</td>
                <td class="text-xs-left">
                  <v-badge color="blue">
                    <span slot="badge">{{ props.item.tripCount }}</span>
                  </v-badge>
                </td>
                <td class="text-xs-right">{{ props.item.user.email }}</td>
                <td class="text-xs-center">
                  <!-- <v-btn icon flat color="grey"><v-icon>edit</v-icon></v-btn> -->
                  <v-btn icon flat color="red lighten-3">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </transition>

    <transition name="fadeToggle" mode="out-in" v-else>
      <layout-no-padding>
        <v-flex v-for="(item, i) in dockets" :key="i" xs12 md4>
          <v-card>
            <v-card-title>
              <div>
                <h3 class="title font-weight-regular mb-2">{{item.name}}</h3>
                <p class="font-weight-light grey--text">Something goes here</p>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </layout-no-padding>
    </transition>

    <!-- <v-dialog v-model="showDocket" lazy max-width="700px">
            
    </v-dialog>-->
    <docket :docket="activeDocket[0]" v-model="showDocket" v-if="!!activeDocket[0]"></docket>
    <snack-bar ref="snackbar"></snack-bar>
  </layout-no-padding>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DocketService from "@/services/requests/docketService";
import SocketService from "@/services/socketApi";
import Docket from "@/components/dockets/docket";

export default {
  data() {
    return {
      color: "blue",
      searchTerm: "",
      showDocket: false,
      activeDocketId: "",
      //itemsEdited: [],
      headers: [
        {
          text: "Docket ID",
          align: "center",
          value: "id"
        },
        {
          text: "External Ref.",
          align: "left",
          value: "externalRef"
        },
        {
          text: "Site",
          align: "left",
          value: "site.id"
        },
        {
          text: "Contractor",
          align: "left",
          value: "driver.contractor.id"
        },
        {
          text: "Vehicle",
          align: "left",
          value: "vehicle.id"
        },
        {
          text: "Driver",
          align: "left",
          value: "driver.id"
        },
        {
          text: "Trips",
          align: "left",
          value: "tripCount"
        },
        {
          text: "Updated By",
          align: "right",
          value: "user.id"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false
        }
      ],
      socket: SocketService.socket("dockets"),
      snackbar: this.$refs.snackbar
    };
  },
  computed: {
    dockets: Store.getSet({ store: "dockets", prop: "dockets" }),
    listView: Store.getSet({ store: "dockets", prop: "listView" }),
    activeDocket() {
      return this.dockets.filter(docket => {
        return docket.id == this.activeDocketId;
      });
    }
  },
  methods: {
    getAllDockets() {
      DocketService.getAllDockets()
        .then(res => {
          //console.log(res.data);
          this.dockets = res.data.result;
          //this.itemsEdited = res.data.result;
        })
        .catch(err => {
          this.snackError();
          //console.log("An error occured");
        });
    },
    openDocket(docket) {
      this.activeDocketId = docket.id;
      this.showDocket = true;
    },

    socketActions() {
      var socket = this.socket;
      socket.on("connect", () => {
        //console.log('socket connected');
        this.$refs.snackbar.display({
          text: "You are now receiving live updates.",
          color: "green"
        });
      });
      socket.on("disconnect", () => {
        //console.log('socket disconnected');
        this.$refs.snackbar.display({
          text: "No longer receiving live updates.",
          color: "red"
        });
      });
      socket.on("newDocket", data => {
        //console.log(data);
        var item = data.result;
        item.user = data.user;
        this.items.unshift(item);
        this.$refs.snackbar.display({ text: data.message, color: "blue" });
      });
      socket.on("deletedAllDockets", () => {
        this.items = [];
      });
    },
    save(item) {
      this.$refs.snackbar.display({
        text: item.name + " was edited.",
        color: "blue"
      });
    },
    cancel() {
      this.$refs.snackbar.display({
        text: "Data edit canceled.",
        color: "red"
      });
    }
  },
  mounted() {
    this.getAllDockets();
    this.socket.connect();
    this.socketActions();
  },
  beforeDestroy() {
    this.socket.disconnect();
  },
  components: {
    Docket
  }
};
</script>

<style>
</style>
